import React, { useState, useEffect } from 'react';
import { deleteBankLogin } from '../../../common/constants/api';
import {
  getApplicantionInfo,
  setApplicantionInfo
} from '../../../common/utils/applicantionInfo';
import { navigate } from 'gatsby';
import RejectReasonModal from '../../../common/components/RejectReasonModal/RejectReasonModal';
import PopUp from '../../../common/components/PopUp/PopUp';

const CMRejectLead = ({ show, setShow }) => {
  const [reasonVal, setReasonVal] = useState('');
  const [type, setType] = useState('loading');
  const [text, setText] = useState('');

  const [showLoader, setShowLoader] = useState(false);
  const [dontClose, setDontClose] = useState(true);
  const [blurred, setBlurred] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const delLoginData = () => {
    setText('Rejecting the lead. Please wait!');
    setType('loading');
    setShow(false);
    setShowLoader(true);
    deleteBankLogin(getApplicantionInfo().leadId, reasonVal)
      .then(res => {
        setTimeout(() => {
          setShowLoader(false);
          navigate('/app/dashboard?type=cm');
          setApplicantionInfo({
            ...getApplicantionInfo(),
            applicationStatus: 'In Principle Accepted'
          });
        }, 2000);
        setText('Lead rejected successfully!');
        setType('success');
      })
      .catch(error => {
        setShowLoader(false);
      });
  };

  useEffect(() => {
    if (!reasonVal) {
      setErrorMessage('required');
    } else if (reasonVal && reasonVal?.length < 10) {
      setErrorMessage('Too Short');
    } else {
      setErrorMessage('');
    }
  }, [reasonVal]);
  return (
    <div className="w-full">
      <RejectReasonModal
        showRejectModal={show}
        setShowRejectModal={setShow}
        rejectReasonMsg={reasonVal}
        setRejectResonMsg={setReasonVal}
        isError={errorMessage && blurred}
        rejectDocFun={delLoginData}
        text="You need to Login again? reject the lead.."
        docId={null}
        title="Reject Lead"
        onBlur={() => setBlurred(true)}
        onFocus={() => setBlurred(false)}
        errorMessage={errorMessage}
      />
      <PopUp
        type={type}
        text={text}
        setShow={setShowLoader}
        show={showLoader}
        dontClose={dontClose}
        autoClose={type === 'success'}
      />
    </div>
  );
};

export default CMRejectLead;
